import { render, staticRenderFns } from "./ChefProfile.vue?vue&type=template&id=4504c8fa&"
import script from "./ChefProfile.vue?vue&type=script&lang=js&"
export * from "./ChefProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports